import { useLocation } from "@reach/router";
import { useEventContext } from "../context/EventProvider";
import { Speaker } from "../interfaces/interfaces";
import useEventDetails from "./useEventDetails";

export default function getEventSchema() {
  const { event, speakers } = useEventContext();
  const { pathname } = useLocation();
  const { virtual } = useEventDetails();
  const {
    title,
    description,
    url,
    facebookImage,
    twitterImage,
    producer,
    producerSite,
    addresses,
    startDate,
    endDate,
  } = event;

  const {
    location,
    streetAddress,
    addressLocality,
    postalCode,
    addressRegion,
    addressCountry,
  } = addresses[0];

  const speakersFormatted: Speaker[] = speakers.map((speaker) => {
    const {
      title,
      person: { first_name, last_name },
      image,
    } = speaker;

    return {
      image: image?.url ?`${image.url}` : ``,
      name: `${first_name} ${last_name}`,
      title,
    };
  });

  const performer = speakersFormatted.map(
    (speaker: { image: string; name: string; title: string }) => {
      const { image, name, title } = speaker;
      return { "@type": "Person", image, name, jobTitle: title };
    }
  );
  const image = [
    `${facebookImage.url}`,
    `${twitterImage.url}`,
  ];

  const eventType: "Offline" | "Online" = virtual ? "Online" : "Offline";

  const Schema = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: title,
    startDate,
    endDate,
    eventAttendanceMode: `https://schema.org/${eventType}EventAttendanceMode`,
    eventStatus: "https://schema.org/EventScheduled",
    location: [
      {
        "@type": "VirtualLocation",
        url: `${url}${pathname}`,
      },
      {
        "@type": "Place",
        name: location,
        address: {
          "@type": "PostalAddress",
          streetAddress,
          addressLocality,
          postalCode,
          addressRegion,
          addressCountry,
        },
      },
    ],
    image,
    description,
    offers: {
      "@type": "Offer",
      url,
      price: "300", // We just need some fixed amount in here to please the schema code
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
      validFrom: endDate,
    },
    performer,
    organizer: {
      "@type": "Organization",
      name: producer,
      url: producerSite,
    },
  };

  return Schema;
}
